import { useSignupMutation } from 'util/rtk-api'
import { useDocTitle } from 'util/hooks'

import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import 'css/pages/signup.css'
import { showMutationError } from 'util/mutation-error'
import { AuthBackdrop } from 'auth/auth-backdrop'

export const Signup = () => {
	const navigate = useNavigate()
	const [ signup ] = useSignupMutation()

	const [ firstName, setFirstName ] = useState()
	const [ lastName, setLastName ] = useState()
	const [ email, setEmail ] = useState()
	const [ password, setPassword ] = useState()

	const onPasswordBlur = ({ target }) => {
		const conditions = [
			/.{8,}/,
			/[0-9]+/,
			/[a-z]+/,
			/[A-Z]+/,
			/[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]+/,
		]

		setPassword(target.value)

		if (
			conditions.every(pattern => target.value.match(pattern))
		) {
			target.setCustomValidity('')
			return
		}
		
		target.setCustomValidity(
			'The password must be at least 8 characters long and must use a lower case character, an upper case character, a number, and a special character.'
		)
	}

	const onConfirmPasswordBlur = ({ target }) => {
		if (
			target.value === password
		) {
			target.setCustomValidity('')
			return
		}

		target.setCustomValidity(
			'This does not match the password entered above'
		)
	}

	const onFormSubmit = async e => {
		e.preventDefault()

		const result = await signup({ firstName, lastName, email, password })

		if (showMutationError(result)) return

		// EH-17: the server answers identically whether or not the email already
		// has an account (no enumeration), so there is no 'already exists' branch
		// here. The verification page states the neutral case and offers Log in.
		navigate(`/verification?email=${email}`)
	}

	useDocTitle('All for One - Sign up')

	return (
		<div className="auth-page">
			<AuthBackdrop />
		<section className="signup-container">
			{/* mockup's sign-up screen: eyebrow / heading / rule / sub-copy.
			    All four were missing here; the log-in screen already had them. */}
			<span className="signup-eyebrow">Create account</span>
			<h1 className="signup-header">Get started</h1>
			<div className="signup-rule" />
			<p className="signup-sub">Create your account to start designing lessons for every mind.</p>

			<form
				id="signup-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
				<div className="form-group">
					<label htmlFor="first-name" className="field-label">First name</label>
					<input 
						type="text" 
						id="first-name" 
						name="first-name" 
						placeholder="First Name" 
						required
						onChange={({ target }) => setFirstName(target.value)}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="last-name" className="field-label">Last name</label>
					<input 
						type="text" 
						id="last-name" 
						name="last-name" 
						placeholder="Last Name" 
						required
						onChange={({ target }) => setLastName(target.value)}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="email" className="field-label">Email</label>
					<input 
						type="email" 
						id="email" 
						name="email" 
						placeholder="Email" 
						required
						onChange={({ target }) => setEmail(target.value)}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="password" className="field-label">Password</label>
					<input 
						type="password" 
						id="password" 
						name="password" 
						placeholder="Password" 
						required
						onBlur={onPasswordBlur}
					/>
				</div>

				<div className="form-group">
					<label htmlFor="confirm-password" className="field-label">Confirm password</label>
					<input 
						type="password" 
						id="confirm-password" 
						name="confirm-password" 
						placeholder="Confirm Password" 
						required
						onBlur={onConfirmPasswordBlur}
					/>
				</div>

				{/* not wrapped in .form-group -- the mockup has the button as a
				    direct child, and wrapping it here made it, not the last
				    input, the last field for spacing purposes */}
				<button type="submit" className="signup-btn">Create account</button>
			</form>

			{/* mockup .divider -- present on both auth screens; this one was missing */}
			<div className="auth-divider"><span>or</span></div>

			<p className="login-prompt">
				Already have an account? <Link to="/login" className="login-link">Log in!</Link>
			</p>
		</section>
		</div>
	)
}
